<div class="card">
    <div class="card-body">


        <div class="col-md-12 col-sm-12 ">
            <div class="form-floating" style="margin-bottom:20px">
                <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                <label for="floatingInputValueSubject">Search for resources</label>
            </div>
            <!--<mat-form-field appearance="standard" style="width:100%">
                <mat-label>Search for resources</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
            </mat-form-field>-->

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                        <td style="width:50%;padding-top: 15px; padding-bottom: 15px;" mat-cell *matCellDef="let row">
                            {{row.fileName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                        <td mat-cell *matCellDef="let row">
                            <span style="margin-right: 5px;">
                                <i *ngIf="row.fileExtension == 'pdf'" style="color:#D52a29"
                                   class="fa fa-file-pdf fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'other'" style="color: #497ce3"
                                   class="fa fa-file-archive fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'audio'" style="color: #7963e6"
                                   class="fa fa-file-audio fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'excel'" style="color: #6aab20"
                                   class="fa fa-file-excel fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'image'" style="color: #ea7130"
                                   class="fa fa-file-image fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'video'" style="color: #7a8387"
                                   class="fa fa-file-movie fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'word'" style="color: #497ce3"
                                   class="fa fa-file-word fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'powerpoint'" style="color: #d52a29"
                                   class="fa fa-file-powerpoint fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'discussion'" style="color: #6aab20"
                                   class="fa fa-bullhorn fa-lg"></i>
                                <i *ngIf="row.fileExtension == 'link'" style="color: #ea7130"
                                   class="fas fa-link fa-lg"></i>
                            </span>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Added by </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.addedByName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Added on </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.createdDate | date:'medium'}}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr style="padding:10px" class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of users"></mat-paginator>
            </div>

        </div>
    </div>
</div>